// extracted by mini-css-extract-plugin
module.exports = {"headerWithText":"header-with-text-module--header-with-text--1enC1","headerWithText__text":"header-with-text-module--header-with-text__text--1fBWa"};